import React, { useState } from "react";
import { Dialog } from "@mui/material";
import styles from "./randomize_modal.module.css";
import main_styles from "../randomize.module.css";
import SignaturePassword from "ui/crfs/signature_password";
import { Checkbox } from "@mui/material";
import DividerLine from "ui/crfs/divider_line";
import LoadingButton from "@mui/lab/LoadingButton";
import router from "routes";

export default function VerifyModal(props) {
  const {
    closeRandomizationModal,
    subject_id,
    domain_name,
    showing,
    handleRandomize,
    data,
    questions,
    showCancel,
    notice,
    proceed,
  } = props;

  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");

  const message_content = () => {
    if (data.reason === "recent_user_randomized") {
      return (
        <div className={styles.modal_text}>
          You enrolled a subject into {data.domain_name} within the last 30 minutes.
        </div>
      );
    } else if (data.reason === "matching_subject_data") {
      return (
        <div className={styles.modal_text}>
          A subject {data.subject_id} was enrolled into {data.domain_name} with the same data in the last 30 minutes.
        </div>
      );
    }
  };

  return (
    <Dialog open={showing} onClose={closeRandomizationModal}>
      <div className={styles.hover_menu_center}>
        <div>
          <div className={styles.header}>
            <div className={main_styles.title}>{domain_name} Duplicate Randomization Check</div>
          </div>

          {message_content()}
          <div className={styles.modal_text}>
            Please confirm you would like to proceed and that this is not a duplicate randomization, or go to the
            subject list instead.
          </div>
          <div className={styles.button_wrapper}>
            <LoadingButton variant="contained" loading={false} onClick={() => router.navigate(`/subjects`)}>
              Go to Subject List
            </LoadingButton>
            <LoadingButton variant="outlined" loading={false} onClick={proceed}>
              Continue
            </LoadingButton>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
